import type { PublishingForm } from './types';

export function formatPublishingForm(publishingForm: any): PublishingForm {
  return {
    apiDocsUrl: publishingForm?.api_docs_url ?? '',
    expectedResponseTime: publishingForm?.expected_response_time ?? '',
    homepageUrl: publishingForm?.homepage_url ?? '',
    id: publishingForm?.id ?? NaN,
    marketingContactEmail: publishingForm?.marketing_contact_email ?? '',
    paidApi: publishingForm?.paid_api ?? '',
    primaryColor: publishingForm?.primary_color ?? '',
    secondaryColor: publishingForm?.secondary_color ?? '',
    technicalContactEmail: publishingForm?.technical_contact_email ?? '',
    testAccountPassword: publishingForm?.test_account_password ?? '',
    testAccountUsername: publishingForm?.test_account_username ?? '',
    testAccountNotes: publishingForm?.test_account_notes ?? '',
    twitterUsername: publishingForm?.twitter_username ?? '',
  };
}
